import { useState, useEffect, useContext, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { APIGetMyPlans } from '../../api/plans/Plans';
import { PlanInfo } from './planInfo';
import { APIUpdateMapPlans } from '../../api/maps/Maps';
import { UserContext } from '../../context/UserContext';
import { XMarkIcon } from '@heroicons/react/24/outline'


export default function PlanToMapPicker({ mapId, mapPlans, showPicker, setShowPicker }) {
    const { user } = useContext(UserContext);
    const [myPlans, setMyPlans] = useState([]);
    const [newMapPlans, setNewMapPlans] = useState(mapPlans);
    const [availableHeight, setAvailableHeight] = useState(0);
    const [sort, setSort] = useState('name');

    const sortPlan = (plan, parameter) => {
        if (parameter === 'createdAt' || parameter === 'updatedAt') {
            return plan?.sort((a, b) =>
                b[parameter].localeCompare(a[parameter])
            );
        } else if (parameter === 'selected') {
            return plan?.sort((a, b) => b[parameter] - a[parameter]);
        }
        return plan?.sort((a, b) => a[parameter].localeCompare(b[parameter]));
    };

    const updateHeight = () => {
        const headerHeight = document.getElementById('header').offsetHeight;
        const footerHeight = document.getElementById('footer').offsetHeight;
        const availableHeight =
            window.innerHeight - headerHeight - footerHeight - 170;
        setAvailableHeight(availableHeight);
    };

    const handleClick = async (selected, id) => {
        if (selected) {
            setNewMapPlans(newMapPlans.filter((p) => p !== id));
        } else {
            setNewMapPlans([...newMapPlans, id]);
        }
    };

    const handleSave = async () => {
        await APIUpdateMapPlans(newMapPlans, mapId, user?.companyId);
        window.location.reload();
    };

    const getAmountOfChanges = () => {
        const beforeSet = new Set(mapPlans);
        const afterSet = new Set(newMapPlans);

        const deletions = mapPlans.filter((id) => !afterSet.has(id)).length;
        const additions = newMapPlans.filter((id) => !beforeSet.has(id)).length;

        return deletions + additions;
    };

    useEffect(() => {
        async function fetchData() {
            const result = await APIGetMyPlans(user?.companyId);
            setMyPlans(result);
        }

        fetchData();

        updateHeight();
        window.addEventListener('resize', updateHeight);

        return () => {
            window.removeEventListener('resize', updateHeight);
        };
    }, [user?.companyId]);

    return (
        <Transition.Root show={showPicker} as={Fragment}>
            <Dialog className="relative z-10" onClose={setShowPicker}>
                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 z-50 right-0 flex max-w-full pl-10 sm:pl-16  mt-[59px] lg:mt-[0px]  sideOver ">
                            <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white px-2 py-14 shadow-xl">
                                        <div className="px-4 " id='header'>
                                            <div className="flex items-start justify-between">
                                                <Dialog.Title className="text-xl px-2 mb-6 font-semibold leading-6 text-gray-900">Pläne zur Karte hinzufügen</Dialog.Title>
                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        className="relative rounded-md bg-white text-gray-900 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                                        onClick={() => setShowPicker(false)}
                                                    >
                                                        <span className="absolute -inset-2.5" />
                                                        <span className="sr-only">Close panel</span>
                                                        <XMarkIcon className="h-9 w-9 " aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                            <p className='p-2'>
                                                Gruppieren Sie Ihre XPläne auf eigenen Karten
                                                und teilen Sie diese mit Bürgern, Partnern oder
                                                veröffentlichen Sie diese auf Ihrer Webseite.
                                            </p>
                                        </div>
                                        <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                            <div className=' w-full rounded-lg flex-col flex overflow-hidden'>
                                                <div className='flex flex-row justify-between'>
                                                    <div className='flex flex-col'>

                                                        <h3 className='font-semibold mb-2 mt-4 leading-6 text-gray-900' id='heading2' >
                                                            Verfügbare Pläne:
                                                        </h3>
                                                    </div>
                                                    <select
                                                        id='sort'
                                                        name='sort'
                                                        className='mt-3 mb-1 py-0 rounded w-42 text-xs border border-gray-900 text-gray-900 h-8 self-end'
                                                        onChange={(e) => {
                                                            setSort(e.target.value);
                                                        }}
                                                    >
                                                        <option key={0} value='name'>
                                                            Name
                                                        </option>
                                                        <option key={1} value='createdAt'>
                                                            Erstellt
                                                        </option>
                                                    </select>
                                                </div>
                                                <div
                                                    className='mb-4 flex-1 border  border-gray-300 my-2 p-4 overflow-y-scroll   messagingList rounded'
                                                    style={{
                                                        maxHeight: `${availableHeight}px`,
                                                    }}
                                                >
                                                    {myPlans?.length === 0 ? (
                                                        <p className='text-gray-600'>
                                                            Keine Pläne verfügbar
                                                        </p>
                                                    ) : (
                                                        sortPlan(myPlans, sort).map(
                                                            (plan, index) => {
                                                                return (
                                                                    <PlanInfo
                                                                        plan={plan}
                                                                        newMapPlans={newMapPlans}
                                                                        handleClick={handleClick}
                                                                        key={index}
                                                                    />
                                                                );
                                                            }
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                            <div className='px-4 py-2 flex flex-row-reverse' id='footer'>
                                                <button
                                                    onClick={handleSave}
                                                    className={`border-2 border-gray-900 rounded p-2 px-4 ${
                                                        getAmountOfChanges() === 0
                                                            ? 'opacity-50 cursor-not-allowed'
                                                            : ''
                                                    }`}
                                                    disabled={getAmountOfChanges() === 0}
                                                >
                                                    {getAmountOfChanges() === 0
                                                        ? 'Änderung speichern'
                                                        : ` Änderung (${getAmountOfChanges()}) speichern`}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </div>
        </Dialog>
    </Transition.Root>
    );
}
